(function () {
  'use strict';

  var SEL_ATC = '.product-form__buttons .product-form__submit';

  function getHandle() {
    var p = location.pathname;
    if (p.endsWith('/')) p = p.slice(0, -1);
    return p.split('/').pop() || '';
  }

  function getContainer() {
    var atc = document.querySelector(SEL_ATC);
    return atc ? atc.closest('.product-form__buttons') : null;
  }

  function revealAll() {
    var all = document.querySelectorAll('.product-form__buttons');
    for (var i = 0; i < all.length; i++) {
      all[i].style.visibility = 'visible';
    }
  }

  function setContent(btn, isUA, cfg) {
    if (isUA) {
      btn.textContent = cfg.textOnButtonUkraine || 'Купити на Stameski';
    } else if (cfg.logoUrl) {
      btn.innerHTML = 'Buy on <img class="amz-logo" src="' + cfg.logoUrl + '" alt="amazon" width="65" height="20">';
    } else {
      btn.textContent = cfg.textOnButton || 'Buy on Amazon';
    }
  }

  function bindClick(btn, url) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'amazon_click',
        product_handle: getHandle(),
        amazon_url: url
      });
      window.open(url, '_blank');
    }, true);
  }

  function renderButton(item, country) {
    var atc = document.querySelector(SEL_ATC);
    if (!atc) { revealAll(); return; }

    var container = atc.closest('.product-form__buttons');
    if (!container || container.dataset.amzDone) { revealAll(); return; }
    container.dataset.amzDone = '1';

    var cfg = window.amzConfig || {};
    var mode = item.b || 1;
    var isUA = country === 'UA';

    var amzBtn = container.querySelector('[data-amz-btn]');
    var orSep  = container.querySelector('[data-amz-sep]');
    if (!amzBtn) { revealAll(); return; }

    setContent(amzBtn, isUA, cfg);
    bindClick(amzBtn, item.u);
    amzBtn.removeAttribute('aria-hidden');
    if (isUA) amzBtn.classList.add('buy-on-amazon-btn--stameski');

    if (mode === 2) {
      // Double layout — space already reserved (visibility:hidden) by country class.
      // Ensure layout class is present, then just flip visibility. No reflow → no jump.
      container.classList.add('amz-layout-double');
      container.classList.remove('amz-layout-single');
      if (orSep) {
        orSep.style.visibility = 'visible';
        orSep.removeAttribute('aria-hidden');
      }
      amzBtn.style.visibility = 'visible';
    } else {
      // Single layout — replace ATC with solo button (same 48px height → no jump).
      container.classList.add('amz-layout-single');
      container.classList.remove('amz-layout-double');
      amzBtn.classList.add('buy-on-amazon-btn--solo');
      if (orSep) orSep.style.display = 'none';
      atc.style.display = 'none';
      amzBtn.style.display = 'inline-flex';
      amzBtn.style.width = '100%';
      amzBtn.style.visibility = 'visible';
    }

    // ── Sticky bar: mirror the main logic ──
    var stickyAction = document.querySelector('[data-bc-sticky-action]');
    if (stickyAction) {
      var stickyAmz = stickyAction.querySelector('[data-amz-sticky-btn]');
      var stickySubmit = stickyAction.querySelector('[data-bc-sticky-submit]');
      if (stickyAmz) {
        setContent(stickyAmz, isUA, cfg);
        bindClick(stickyAmz, item.u);
        if (isUA) stickyAmz.classList.add('buy-on-amazon-btn--stameski');
        stickyAmz.removeAttribute('aria-hidden');
        stickyAmz.style.display = 'inline-flex';

        if (mode === 1) {
          // Single — Stameski replaces ATC (filled style).
          stickyAmz.classList.add('buy-on-amazon-btn--solo');
          if (stickySubmit) stickySubmit.style.display = 'none';
        }
        // mode 2 — ATC stays, Amazon stacked below (no "or" separator).
      }
    }

    revealAll();
  }

  function handleNoItem() {
    // Product not in set: collapse any reserved double-layout space so there's no empty
    // gap, then reveal the plain ATC. (Single-layout pages need no change.)
    var container = getContainer();
    if (container) container.classList.remove('amz-layout-double');
    revealAll();
  }

  function init(data) {
    if (!data.set || !data.set.length) { handleNoItem(); return; }

    var handle = getHandle();
    var item = null;
    for (var i = 0; i < data.set.length; i++) {
      if (data.set[i].h === handle) { item = data.set[i]; break; }
    }
    if (!item) { handleNoItem(); return; }

    var country = data.country || '';

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { renderButton(item, country); });
    } else {
      renderButton(item, country);
    }
  }

  if (window.amzData) {
    init(window.amzData);
  } else {
    window.addEventListener('amz:ready', function (e) { init(e.detail); }, { once: true });
  }
})();
